var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenenergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_585_2021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_585_2021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9457 17.4727H12.1994C11.0343 17.4727 10.0898 16.5282 10.0898 15.3631C10.0898 14.1981 11.0343 13.2537 12.1994 13.2537H16.9457",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3086 13.2537V17.4727",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99993 7.94531H6.32405C3.70512 7.94531 1.58203 5.82223 1.58203 3.2033V0.527414H4.25791C6.87684 0.527414 8.99993 2.6505 8.99993 5.26943V7.94531Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25062 5.19727H2.01953",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25195 5.19727V0.966176",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 0.527484L9.54309 8.48855C10.7114 9.65682 9.88397 11.6543 8.2318 11.6543H4.49125C3.46707 11.6543 2.63679 12.4846 2.63679 13.5088C2.63679 14.533 3.46707 15.3633 4.49125 15.3633H10.0893",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenenergy);
export default __webpack_public_path__ + "static/media/greenenergy.31967d128bad7193830fb0e6e89606b3.svg";
export { ForwardRef as ReactComponent };